/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowchangeentry3Inputs */

const en_aiflowchangeentry3 = /** @type {(inputs: Aiflowchangeentry3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change the entry`)
};

const de_aiflowchangeentry3 = /** @type {(inputs: Aiflowchangeentry3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eintritt ändern`)
};

/**
* | output |
* | --- |
* | "Change the entry" |
*
* @param {Aiflowchangeentry3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowchangeentry3 = /** @type {((inputs?: Aiflowchangeentry3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowchangeentry3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowchangeentry3(inputs)
	return de_aiflowchangeentry3(inputs)
});
export { aiflowchangeentry3 as "aiFlowChangeEntry" }